import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-hero-auction',
  templateUrl: './hero-auction.component.html',
  styleUrls: ['./hero-auction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroAuctionComponent {
  @Input() lang = 'ru';
}
